import { CustomEntityService } from './../../apiclient/api/customEntity.service';
import { Component, OnInit } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { UserSessionService } from './../../UserSession/user-session.service';
import {Location} from '@angular/common';
import { Router } from '@angular/router';
@Component({
  selector: 'ngx-customentities',
  templateUrl: './customentities.component.html',
  styleUrls: ['./customentities.component.scss']
})
export class CustomentitiesComponent implements OnInit {

  settings = {
    actions: {
      delete: false,
      add: false,
      edit:true,
      position: 'right',
      columnTitle:'',
  },
  edit: {
    editButtonContent: '<i class="nb-edit"></i>',
    saveButtonContent: '<i class="nb-checkmark"></i>',
    cancelButtonContent: '<i class="nb-close"></i>',
  },
  mode:'external',




    columns: {
      id: {
        title: 'ID',
        type: 'number',
      },
      company_name: {
        title: 'Compañía',
        type: 'string',
      },
      name: {
        title: 'Nombre',
        type: 'string',
      },
      geospatial: {
        title: 'Geoespacial',
        type: 'boolean',
      }
    },
  };

  source: LocalDataSource = new LocalDataSource();

  constructor(private userSessionService: UserSessionService,
    private entityService: CustomEntityService, private location: Location,
    private router: Router) { }

  ngOnInit(): void {
    this.entityService.customEntitieslist(this.userSessionService.accessToken).subscribe(data => {
        this.source.load(data);
    })
  }



  /**
   * Vuelve a la página anterior
   */
   back(): void{
    this.location.back()
   }


   editarEntidad(evento): void {
      console.log(evento)
      this.router.navigate(['pages/customentity',evento.data.company_id, evento.data.id]);
   }

}
